import(/* webpackMode: "eager" */ "/codebuild/output/src3418830091/src/apps/fanychance/src/app/error.tsx");
